var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTariffChainBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2847 15.8572C11.2847 17.1197 10.2615 18.1429 9.00002 18.1429C7.73859 18.1429 6.71538 17.1197 6.71538 15.8572M16.6926 13.7961C16.0025 13.0547 14.7114 11.9393 14.7114 8.28575C14.7114 5.51076 12.7657 3.28931 10.1422 2.74432V2.00003C10.1422 1.36896 9.63074 0.857178 9.00002 0.857178C8.36931 0.857178 7.85789 1.36896 7.85789 2.00003V2.74432C5.23431 3.28931 3.28859 5.51076 3.28859 8.28575C3.28859 11.9393 1.99752 13.0547 1.30752 13.7961C1.09324 14.0264 0.998239 14.3019 1.00002 14.5715C1.00395 15.1572 1.4636 15.7143 2.14646 15.7143H15.8536C16.5365 15.7143 16.9965 15.1572 17 14.5715C17.0018 14.3019 16.9069 14.0261 16.6926 13.7961Z",
    stroke: "#AA8B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffChainBell);
export default __webpack_public_path__ + "static/media/tariffChainBell.723585d9.svg";
export { ForwardRef as ReactComponent };